import gql from 'graphql-tag';

export const ProjectsCountQuery = gql`
  query ProjectsCountQuery($filters: EstateFilterInput!) {
    estateCount(filters: $filters)
  }
`;
